
export enum DesignStatus {
  Unknown = 'unknown',
  Draft = 'draft',
  Rejected = 'rejected',
  Approval = 'approval',
  Done = 'done'
}